// src/pages/Users/Users.jsx
import React from 'react';
import UserManagement from './UserManagement';

const Users = () => {
  return <UserManagement role="user" title="User" />;
};

export default Users;